var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 5110 c-482 -43 -950 -230 -1350 -538 -195 -150 -448 -432 -594 -662 -63 -99 -186 -351 -230 -471 -49 -134 -102 -340 -128 -499 -31 -195 -31 -565 0 -760 45 -276 116 -498 237 -745 132 -269 269 -460 489 -681 221 -220 412 -357 681 -489 247 -121 469 -192 745 -237 195 -31 565 -31 760 0 159 26 365 79 499 128 120 44 372 167 471 230 321 204 620 503 824 824 63 99 186 351 230 471 83 228 140 508 152 759 8 154 0 191 -49 247 -102 116 -291 65 -326 -87 -6 -25 -11 -79 -11 -122 0 -114 -28 -306 -65 -454 -191 -763 -806 -1378 -1569 -1569 -349 -88 -729 -87 -1076 1 -856 219 -1501 947 -1614 1822 -20 158 -20 406 0 564 112 874 759 1603 1614 1822 150 38 342 66 458 66 143 1 216 34 253 114 47 103 7 209 -96 257 -44 20 -144 23 -305 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4795 4471 c-16 -4 -41 -13 -55 -21 -14 -7 -549 -536 -1190 -1176 l-1165 -1162 -290 315 c-537 585 -565 614 -613 635 -91 41 -199 3 -241 -84 -27 -56 -27 -127 -2 -176 17 -33 305 -350 849 -936 182 -196 220 -226 292 -226 84 0 68 -15 1372 1287 1348 1346 1287 1280 1276 1378 -13 110 -129 192 -233 166z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/Accept.af481d5236368e771dcc664fc1fdee6f.svg";
export { ForwardRef as ReactComponent };